import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser($input: UserInput!) {
    createUser(input: $input) {
      id
      firstName
      lastName
      userName
      email
      emailSignature
      resetSentOn
      lastLogin
      createdAt
      updatedAt
    }
  }
`;
export const UPDATE_USER = gql`
  mutation UpdateUser($id: UUID!, $input: UserInput!) {
    updateUser(id: $id, input: $input) {
      id
      firstName
      lastName
      userName
      email
      emailSignature
      resetSentOn
      lastLogin
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    users {
      id
      firstName
      lastName
      userName
      email
      emailSignature
      resetSentOn
      lastLogin
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER = gql`query CurrentUser { user { id userName firstName lastName email emailSignature isSuperAdmin } }`;
export const GET_USER_STATS = gql`
 query UserStats($from: String!, $to: String!) {
  userStats(from:$from, to:$to) {
   trackingStartedAt timeZone partialTracking
   rows { id name email quotesSent paidQuotes closedRevenue notesAdded emailsSent uniqueLeadsEmailed optionsSent }
  }
 }
`;
